import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en/resources-en.json';
import de from './de/resources-de.json';

const resources = {
  en,
  de,
};

i18n.use(initReactI18next).init({
  resources,
  lng: window.localStorage.getItem('LANG') || 'en',
  fallbackLng: ['en', 'de'],
  returnEmptyString: false,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
